export const glucoseSliderReadings = (value: number) => {
  if (value < 5) {
    return { message: "Too Low", color: "bg-red-400" };
  } else if (20 <= value) {
    return { message: "Too High", color: "bg-red-400" };
  } else {
    return { message: "Normal", color: "bg-green-400" };
  }
};
